// This file contains the predicted LTV values for each feedback rating (0-10) based on historical data analysis.
// They are pre-calculated and can be used to estimate the LTV of a customer based on their first feedback rating.
// This is the amount of revenue we expect to generate from a customer, multiplied by 0.3 to have the margin we can expect from that revenue.
const feedbackRatingPredictedLtv = {
  0: 106.4,
  1: 159.07,
  2: 147.65,
  3: 169.53,
  4: 180.33,
  5: 197.65,
  6: 211.23,
  7: 235.79,
  8: 233.17,
  9: 233.48,
  10: 226.45,
};

export default feedbackRatingPredictedLtv;
